<div *ngIf="loading" class="report-loading">
  <i class="pi pi-spin pi-spinner" aria-label="Loading reports"></i>
</div>
<div *ngIf="!loading" class="report-table-scroll">
  <p-table
    [value]="reports"
    [paginator]="reports.length > pageSize"
    [first]="first"
    (onPage)="first = $event.first"
    [rows]="pageSize"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first}–{last} of {totalRecords}"
    styleClass="p-datatable-sm p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Data Type</th>
        <th>Chart Type</th>
        <th class="report-delete-col" aria-label="Actions"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-report>
      <tr>
        <td>
          <span class="report-name-cell">
            <span class="report-order-actions" aria-label="Reorder report">
              <button type="button" class="report-icon-button" aria-label="Move up"
                pTooltip="Move up" [disabled]="reordering || reports[0]?.id === report.id"
                (click)="moveReport(report, -1, $event)"><i class="pi pi-chevron-up"></i></button>
              <button type="button" class="report-icon-button" aria-label="Move down"
                pTooltip="Move down" [disabled]="reordering || reports[reports.length - 1]?.id === report.id"
                (click)="moveReport(report, 1, $event)"><i class="pi pi-chevron-down"></i></button>
            </span>
            <button type="button" class="report-name" (click)="onReportClick(report)">{{ report.name }}</button>
          </span>
        </td>
        <td>{{ formatType(report.dataType) }}</td>
        <td>{{ formatType(report.chartType) }}</td>
        <td class="report-delete-col">
          <button type="button" class="report-delete" aria-label="Delete report"
            pTooltip="Delete report" (click)="onDeleteClick(report, $event)">
            <i class="pi pi-times"></i>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="4">No reports</td></tr>
    </ng-template>
  </p-table>
</div>
